import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const IconCircle = ({ className, fill = 'currentColor' }) => {
    return (
        <svg
            className={className}
            fill='none'
            height='40'
            viewBox='0 0 40 40'
            width='40'
            xmlns='http://www.w3.org/2000/svg'>
            <circle
                cx='20'
                cy='20'
                fill={fill}
                r='20'/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconCircle;
